import ContactForm from "pages/Contact";


export default ContactForm;